import { render } from "./Circular.vue?vue&type=template&id=0297d878"
import script from "./Circular.vue?vue&type=script&lang=js"
export * from "./Circular.vue?vue&type=script&lang=js"

import "./Circular.vue?vue&type=style&index=0&id=0297d878&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__